import React from 'react';
import styles from './SystemDetails.module.css';
import { useSelector } from 'react-redux';
import { findSensorValue } from '../../utils/sensorHelpers';
import MetricsCard from '../Shared/MetricsCard';
import SystemGraphCard from './SystemGraphCard';
import CenteredSpinner from '../Shared/CenteredSpinner';
import { useLastMetrics } from '../../hooks/useLastMetrics';
import { Table, TableBody, TableCell, TableRow } from '@material-ui/core';

function SystemScreen({ systemId }) {
  const { lastMetrics, loading: lastEntriesLoading } = useLastMetrics(systemId);
  const system = useSelector((state) => state.bessReducer.details[systemId]);

  const systemInfo = [
    { value: 'id', headerName: 'ID' },
    { value: 'location', headerName: 'Location' },
    { value: 'numberOfCabinets', headerName: 'Cabinets' },
    { value: 'numberOfModules', headerName: 'Modules' },
    { value: 'numberOfCells', headerName: 'Cells' }
  ];

  return (
    <div className={styles.systemScreenContainer}>
      <div className={styles.systemAnalyticsContainer}>
        <SystemGraphCard systemId={systemId} />
      </div>
      <div className={styles.systemValuesContainer}>
        <div style={{ height: '100%' }}>
          {lastEntriesLoading ? (
            <CenteredSpinner />
          ) : (
            <div className={styles.systemMetricsContainer}>
              <MetricsCard
                value={findSensorValue(lastMetrics, 'Power', 'kW')}
                subtext={'Power'}
              />
              <MetricsCard
                value={findSensorValue(lastMetrics, 'SOC', '%')}
                subtext={'SOC'}
              />
              <MetricsCard
                value={findSensorValue(lastMetrics, 'Current', 'A')}
                subtext={'Current'}
              />
              <MetricsCard
                value={findSensorValue(lastMetrics, 'Temperature', '°C')}
                subtext={'Temperature'}
              />
              <MetricsCard
                value={findSensorValue(lastMetrics, 'SystemCapacity', 'kWh')}
                subtext={'Capacity'}
              />
              <MetricsCard
                value={findSensorValue(lastMetrics, 'SystemVoltage', 'V')}
                subtext={'Voltage'}
              />
            </div>
          )}
        </div>
        <div className={styles.systemInfo}>
          <Table>
            <TableBody>
              {systemInfo.map(({ value, headerName }) => (
                <TableRow key={value}>
                  <TableCell>{headerName}</TableCell>
                  <TableCell>{system[value]}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
}

export default SystemScreen;
